import { Flex } from 'components';
import { Icon } from 'shared/components';

interface IProps {
  icon: React.ReactNode;
  title?: React.ReactNode | null;
  value?: React.ReactNode | null;
}

function DataRow(props: IProps) {
  return (
    <Flex gap={5}>
      <div>
        <Icon color='red'>{props.icon}</Icon>
      </div>
      {props.title != null && (
        <div>
          <b>{props.title}</b>
        </div>
      )}

      {props.value != null && <span>{props.value}</span>}
    </Flex>
  );
}

export default DataRow;
